import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import ListGroup from '@vfuk/core-list-group'
import ListItem from '@vfuk/core-list-item'
import { advancedSpacing, respondTo, responsiveSizing, typography } from '@vfuk/core-mixins'

import type { StyledSearchSuggestionProps } from './SearchSuggestion.style.types'

export const SearchSuggestion = styled.div(
  (): FlattenSimpleInterpolation => css`
    position: relative;
  `,
)

export const SuggestionList = styled(ListGroup)(
  (props: StyledSearchSuggestionProps): FlattenSimpleInterpolation => css`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1;
    background: ${props.theme.formFields.backgroundColor};
    border-radius: 0 0 ${props.theme.formFields.border.radius} ${props.theme.formFields.border.radius};
    max-height: 0;
    overflow: auto;
    transition: 0.4s all ease;
    cursor: pointer;

    ${props.isOpen &&
    css`
      border: ${props.theme.formFields.border.width} ${props.theme.formFields.border.style} ${props.theme.formFields.border.color};
      transform: translateY(-${props.theme.border.radius[2]});
      padding: ${props.theme.border.radius[2]} 0 0;
      max-height: ${props.theme.spacing.responsive[8].sm * 8}px;
      border-top: none;

      ${respondTo.md(css`
        max-height: ${props.theme.spacing.responsive[8].md * 8}px;
      `)}

      ${respondTo.lg(css`
        max-height: ${props.theme.spacing.responsive[8].lg * 8}px;
      `)}

    ${respondTo.xl(css`
        max-height: ${props.theme.spacing.responsive[8].xl * 8}px;
      `)}
    `}
  `,
)

type SuggestionProps = Pick<StyledSearchSuggestionProps, 'theme'>
export const Suggestion = styled(ListItem)(
  (props: SuggestionProps): FlattenSimpleInterpolation => css`
    button {
      ${advancedSpacing('padding', [2, 3])};
      transition: 0.4s all ease;
      ${responsiveSizing('min-height', 8)};
      ${typography.paragraph(2, false)}
      background: ${props.theme.formFields.backgroundColor};
      width: 100%;
      text-align: left;
      border: none;
      color: ${props.theme.formFields.color};
      cursor: pointer;
      display: flex;
      align-items: center;

      &:hover,
      &:focus {
        background: ${props.theme.formFields.selected.backgroundColor};
        color: ${props.theme.formFields.selected.color};
        outline: none;
        box-shadow: none;
      }
    }
  `,
)

export const Subtext = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${typography.paragraph(1, false)};
    margin-left: auto;
  `,
)
